export default __webpack_public_path__ + "a45817803c5fce2680155de361ae1ef6.png";